export default __webpack_public_path__ + "static/toggle-pro-223368aa9f6ea84da131d5143a255f93.png";